export default __webpack_public_path__ + "static/media/app_jack.050cc7a9.png";